import ManagedStaticPage from '../components/ManagedStaticPage';

export default function Terms() {
  return <ManagedStaticPage slug="terms" fallbackTitle="Terms of Service" />;
}
